import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {ReactComponent as ArrowLeft} from '../../../../../@casino/img/left-arrow.svg';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {useStyles} from './helpers';
import {useRouter} from '../../../../../@casino/useRouter';
import { setPostBonusesReferralIssue } from '../../store/thunk/setPostBonusesReferralIssue';
import { useDispatch } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { setPostUpdatePercent } from '../../store/thunk/setPostUpdatePercent';

const TableCasino = ({allPage, perPage, columns, rows, changePage, changeRowsPerPage, width, pagination, route, order, search}) => {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(perPage);
    const [openModal, setOpenModal] = React.useState(false);
    const [openModalPercent, setOpenModalPercent] = React.useState(false);
    const [data, setData] = React.useState({});
    const [percent, setPercent] = React.useState(0);
    const router = useRouter();
    const dispatch = useDispatch();

    return (
        <div style={{maxWidth: width}} className={classes.w100}>
            <TableContainer className={classes.container} >
            <Table stickyHeader aria-label="sticky table" >
                <TableHead >
                <TableRow className={classes.h25}>
                    {columns.map((column, key) => (
                    <TableCell
                        key={column.id}
                        align={column.align}
                        onClick={() => {
                            if (order) {
                                order(column);
                            }
                        }}
                        style={{minWidth: column.minWidth, maxWidth: column.maxWidth, width: column.width, paddingLeft: key === 0 ? 10 : 0}}
                        className={classes.cell}
                    >
                        {column.label}
                    </TableCell>
                    ))}
                </TableRow>
                </TableHead>
                <TableBody className={classes.w100}>
                {rows.map((row, key) => {
                    return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code} style={{background: key % 2 === 0 ? '#141b33' : '#1b2039', cursor: route ? 'pointer' : 'default'}}
                        onClick={(event) => {
                            if (route) {
                                router.history.push(route+row.promocode);
                                
                            }
                        }}
                    >
                        {columns.map((column, key) => {
                        const value = row[column.id];
                       
                        return (
                            <TableCell key={column.id} align={column.align} style={{paddingLeft: 10, height: 50}} className={classes.cellBody}>
                            {column.format && typeof value === 'number' ? column.format(value) : value}
                            {
                                column.id === 'balance' && '₽'
                            }
                            {
                                column.id === 'withdrawal' && 
                                <>
                                    <span 
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            setData(row);
                                            setOpenModal(true);
                                        }}
                                        style={{padding: '5px 15px', marginRight: 12, borderRadius: 4, background: 'rgb(255, 49, 86)', cursor: 'pointer'}}>
                                        Выдать
                                    </span>
                                    <span 
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            setData(row);
                                            setPercent(row.percent);
                                            setOpenModalPercent(true);
                                        }}
                                        style={{padding: '5px 15px', borderRadius: 4, background: 'gold', color: '#000', cursor: 'pointer'}}>
                                    Изменить %
                                    </span>
                                </>
                            }
                            </TableCell>
                        );
                        })}
                    </TableRow>
                    );
                })}
                </TableBody>
                
                
            </Table>
            {
                    rows.length === 0 &&
                  
                    <div className={classes.wrapnodata}>
                        <span className={classes.nodata}>Данных нет</span>
                    </div>
                
                }
            </TableContainer>
            {
                pagination &&
                <div className={classes.wrapPagination}>
                    <select 
                        className={classes.select}
                        value={rowsPerPage}
                        onChange={(v) => {
                            setRowsPerPage(v.target.value);
                            changeRowsPerPage({
                                page: page,
                                rowsPerPage: v.target.value
                            });
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </select>
                    <input type="number" onChange={(v) => setPage(v.target.value)} value={page + 1} className={classes.inputnumber}/>
                    <span className={classes.countPage}>/ {allPage}</span>
                    <div className={classes.ml12}>
                        <span className={classes.arrowleft} onClick={() => {
                            if (page !== 0) {
                                changePage({page: page - 1, rowsPerPage: +rowsPerPage})
                                setPage(page - 1)
                            }
                            
                        }}>
                            <ArrowLeft className={classes.arrowRight}/>
                        </span>
                        <span className={classes.arrowright} onClick={() => {
                            if (page !== +allPage - 1) {
                                changePage({page: page + 1, rowsPerPage: +rowsPerPage})
                                setPage(page + 1)
                            }
                        }}>
                            <ArrowRight className={classes.arrowRight}/>
                        </span>
                    </div>
                </div>
            }
            <Dialog onClose={() => setOpenModal(false)} open={openModal}>
                <div style={{padding: 20}}>
                    <h3 style={{color: '#2f2f2f', margin: 0, padding: 0}}>Выдать реферальный бонус в размере {data.balance} рублей?</h3>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 12, width: '100%'}}>
                        <span 
                            style={{padding: '5px 20px', background: '#ffc324', color: '#141b33', width: '38%',textAlign: 'center', cursor: 'pointer', borderRadius: 4}}
                            onClick={() => {
                                dispatch(setPostBonusesReferralIssue(data)); 
                                setOpenModal(false)
                            }}>Ок</span>
                        <span 
                            onClick={() =>  setOpenModal(false)}
                            style={{padding: '5px 20px', border: '1px solid #ffc324', color: '#141b33', width: '38%',textAlign: 'center', cursor: 'pointer', borderRadius: 4}}>Отмена</span>
                    </div>
                </div>
            </Dialog>
            <Dialog onClose={() => setOpenModalPercent(false)} open={openModalPercent}>
                <div style={{padding: 20}}>
                    <h3 style={{color: '#2f2f2f', margin: 0, padding: 0}}>Изменить % начисления</h3>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', marginTop: 12, width: '100%'}}>
                        <input 
                            type="number" 
                            name="" 
                            id=""
                            value={percent}
                            onChange={(v) => {
                                setPercent(v.target.value);
                            }}
                            style={{border: '1px solid #e5e5e5', borderRadius: 4, padding: 10}}
                            />
                        <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 12}}>
                            <span 
                                style={{padding: '5px 20px', background: '#ffc324', color: '#141b33', width: '38%',textAlign: 'center', cursor: 'pointer', borderRadius: 4}}
                                onClick={() => {
                                    dispatch(setPostUpdatePercent({
                                        percent,
                                        promocode: data.promocode,
                                        page,
                                        rowsPerPage,
                                        search
                                    }))
                                    setOpenModalPercent(false);
                                }}>Ок</span>
                            <span 
                                onClick={() =>  setOpenModalPercent(false)}
                                style={{padding: '5px 20px', border: '1px solid #ffc324', color: '#141b33', width: '38%',textAlign: 'center', cursor: 'pointer', borderRadius: 4}}>Отмена</span>
                         </div>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default TableCasino;